import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { GlobalFormGroup } from '@app/services/formulario';
import { convertErrorsNz } from '@app/utiles/ng-zorro';

@Component({ standalone: false, selector: 'app-form-reactive-input-number',
  templateUrl: './reactive-input-number.component.html',
})
export class FormReactiveInputNumber<T> {
  private static nextId = 0;
  @Input() label: string = '';
  @Input() required = false;
  @Input() labelClass: string = '';
  @Input() secondLabel: string = '';
  @Input() secondLabelClass: string = '';
  @Input() inputId = `number-field-${FormReactiveInputNumber.nextId++}`;
  @Input() fullWidth: boolean = false;
  @Input() inputFormControl: GlobalFormGroup<T> = null;
  @Input() inputClass: string = '';
  readonly convertErrorsNz = convertErrorsNz;
  // Necesario para evitar el error de tipado para [formControl] (https://github.com/ngx-formly/ngx-formly/issues/2842)
  readonly asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;
}
